/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 超3天欠货货期 的 **请求配置**
 *
 * @分类 #4.46.0
 * @请求头 `POST /erp/WcgOwe/overdueList`
 */
const postOverdueListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/WcgOwe/overdueList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postOverdueList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 超3天欠货货期 的 **请求函数**
 *
 * @分类 #4.46.0
 * @请求头 `POST /erp/WcgOwe/overdueList`
 */
export const postOverdueList = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postOverdueListRequestConfig, requestData), ...args);
};
postOverdueList.requestConfig = postOverdueListRequestConfig;
/**
 * 接口 超3天货期-消欠货明细 的 **请求配置**
 *
 * @分类 #4.46.0
 * @请求头 `POST /erp/WcgOwe/overdueDetail`
 */
const postOverdueDetailRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/WcgOwe/overdueDetail",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postOverdueDetail",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 超3天货期-消欠货明细 的 **请求函数**
 *
 * @分类 #4.46.0
 * @请求头 `POST /erp/WcgOwe/overdueDetail`
 */
export const postOverdueDetail = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postOverdueDetailRequestConfig, requestData), ...args);
};
postOverdueDetail.requestConfig = postOverdueDetailRequestConfig;
/**
 * 接口 超3天货期-导出明细 的 **请求配置**
 *
 * @分类 #4.46.0
 * @请求头 `POST /erp/WcgOwe/exportOverdueDetail`
 */
const postExportOverdueDetailRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/WcgOwe/exportOverdueDetail",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExportOverdueDetail",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 超3天货期-导出明细 的 **请求函数**
 *
 * @分类 #4.46.0
 * @请求头 `POST /erp/WcgOwe/exportOverdueDetail`
 */
export const postExportOverdueDetail = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postExportOverdueDetailRequestConfig, requestData),
    ...args
  );
};
postExportOverdueDetail.requestConfig = postExportOverdueDetailRequestConfig;
/**
 * 接口 超3天货期-导出列表 的 **请求配置**
 *
 * @分类 #4.46.0
 * @请求头 `POST /erp/WcgOwe/exportOverdueList`
 */
const postExportOverdueListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/WcgOwe/exportOverdueList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExportOverdueList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 超3天货期-导出列表 的 **请求函数**
 *
 * @分类 #4.46.0
 * @请求头 `POST /erp/WcgOwe/exportOverdueList`
 */
export const postExportOverdueList = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postExportOverdueListRequestConfig, requestData),
    ...args
  );
};
postExportOverdueList.requestConfig = postExportOverdueListRequestConfig;
/**
 * 接口 超3天货期-下拉选项（城市\代采组\待采员） 的 **请求配置**
 *
 * @分类 #4.46.0
 * @请求头 `POST /erp/WcgOwe/overdueOptions`
 */
const postOverdueOptionsRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/WcgOwe/overdueOptions",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postOverdueOptions",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 超3天货期-下拉选项（城市\代采组\待采员） 的 **请求函数**
 *
 * @分类 #4.46.0
 * @请求头 `POST /erp/WcgOwe/overdueOptions`
 */
export const postOverdueOptions = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postOverdueOptionsRequestConfig, requestData),
    ...args
  );
};
postOverdueOptions.requestConfig = postOverdueOptionsRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/wcgOwe.js